<!--经销商选择-->
<template>
  <Modal
    :value="visible"
    @on-visible-change="onVisibleChange"
    :title="title"
    @on-cancel="cancel"
    :footer-hide="true"
  >
    <Input
      v-model="searchName"
      placeholder="请输入产品名称"
      search
      enter-button
      @on-search="handleClickCusSelect"
    ></Input>
    <CTable
      :height="400"
      :columns="columns"
      :data="queryData"
      :total="total"
      :current="params.page"
      :page-size="params.pageSize"
      :showPage="true"
      @change="onPageChange"
    />
  </Modal>
</template>

<script>

import CTable from '../CTable'

export default {
  name: "CusSelectDialog",
  model: {},
  components: {
    CTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "产品选择"
    },
    loadDataEnabled: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    "visible" (newVal) {
      if(newVal) {
        this.searchName=''
        if(this.loadDataEnabled) {
          this.loadDataByName()
        }
      }
    },
  },
  data () {
    return {
      searchName: '',
      modal: false,
      queryData: [],
      total: 0,
      params: {
        page: 1,
        pageSize: 10,
        skuName: '',
        skuCode: ''
      },
      columns: [{
        title: '物料名称',
        key: 'skuName'
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 160,
        render: (h,params) => {
          return h('div',[
            h('a',{
              on: {
                click: () => {
                  this.$emit("on-select",params.row)
                }
              }
            },'选择')
          ])
        }
      }]
    }
  },
  methods: {
    onPageChange (value) {
      const page = Number(value)
      this.params.page = Number.isFinite(page) && page > 0 ? page : 1
      this.loadDataByName('')
    },
    ok () {

    },
    cancel () {
    },
    loadDataByName (value) {
      const page = Number(this.params.page)
      const pageSize = Number(this.params.pageSize)
      this.params.page = Number.isFinite(page) && page > 0 ? page : 1
      this.params.pageSize = Number.isFinite(pageSize) && pageSize > 0 ? pageSize : 10
      this.params.skuName=value
      this.$fetch('SysSku/getList',this.params).then(res => {
        this.queryData=res.data.list
        this.total=res.data.total
      })
    },
    handleClickCusSelect () {
      this.params.page=1
      this.loadDataByName(this.searchName)
    },
    onVisibleChange (value) {
      if (value) {
        this.params.page = 1
        this.params.pageSize = 10
      }
      this.$emit('update:visible',value)
    }
  }
}
</script>

<style scoped>
</style>
